module.exports = __webpack_public_path__ + "img/selectedMbeansBg.ff3eface.svg";